/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { PsDerivation, PsDerivationContent, PsDerivationJudgement, PsTextCondition } from '../../../../api/model';
import SingleSelect from '../../../atoms/SingleSelect';
import { DiffType, PsDetailsMode } from './constants/types';
import PsDerivationContentXmlCell from './PsDerivationContentXmlCell';
import { getDiffBackgroundColor } from './PsDetails';
import PsDiffViewerDialog from './PsDiffViewerDialog';

interface Props {
  /** PS 閲覧・追加・編集・比較の内、どのモードかを示す。 */
  mode: PsDetailsMode;

  /** ラジオボタンの name の独立性 (PS ごと) のために必要な unique な値 & CKFinder に渡す用の PS バージョン ID。PS 追加画面では PsDetails に props 渡した時点での Date.now() の返り値。 */
  psVersionId: number;

  /** ps.derivations の index。 */
  psDerivationIndex: number;

  /** 表示する言語。0: 日本語、1: 米語、2: 英語。 */
  displayLanguages: boolean[];

  /** PsDerivationContent.derivation_content_id と DiffType の Map。 */
  psDerivationContentIdDiffTypeMap: Map<number, DiffType>;
  /** PsDerivationJudgement.derivation_judgement_id と DiffType の Map。 */
  psDerivationJudgementIdDiffTypeMap: Map<number, DiffType>;
  /** PsDerivationContent.derivation_content_id と xml の Map。 */
  psDerivationContentIdDiffXmlMap: Map<number, string>;

  /** PsDerivationJudgement.derivation_judgement_id と value の Map。 */
  psDerivationJudgementIdDiffValueMapRef: Map<number, number>;

  /** PSのコピーペースト用情報。 */
  psNo: string | undefined;
  psDerivationId: number | undefined;
  fsrId: string | undefined;
  psType: number | undefined;
  psLevel: number | undefined;
}

/** PsDetails に含まれるコンポーネント。派生テーブルの一行。 */
function PsDerivationRow({
  mode,
  // psDerivationRecord,
  psVersionId,
  psDerivationIndex,
  displayLanguages,
  psDerivationContentIdDiffTypeMap,
  psDerivationJudgementIdDiffTypeMap,
  psDerivationContentIdDiffXmlMap,
  psDerivationJudgementIdDiffValueMapRef,
  psNo,
  psDerivationId,
  fsrId,
  psType,
  psLevel,
}: Props) {

  /** React Hook Form 用の、derivation_contents を指す name。 */
  const derivationContentsName = `derivations.${psDerivationIndex}.derivation_contents`;

  /** React Hook Form 用の、derivation_judgements を指す name。 */
  const derivationJudgementsName = `derivations.${psDerivationIndex}.derivation_judgements`;

  // 参照: https://qiita.com/y-yasuda/items/9184380d3320d47bc564
  // PsDetails に置かれた FormProvider から取得。
  const { register, control, getValues, setValue } = useFormContext();

  /** watch する derivation_contents。 */
  const derivationContents = useWatch({
    control,
    name: derivationContentsName,
  });

  // console.log(derivationContents);

  // // derivation_contents 用。
  // const {
  //   fields: derivationContentFields,
  //   // append: appendDerivationContent,
  //   // remove: removeDerivationContent,
  //   // update: updateDerivationContent,
  // } = useFieldArray({
  //   control,
  //   name: derivationContentsName,
  // });

  /** watch する text_conditions。 */
  const textConditions = useWatch({
    control,
    name: 'text_conditions',
  });

  /** watch する derivation_judgements。 */
  const derivationJudgements = useWatch({
    control,
    name: derivationJudgementsName,
  });

  // // derivation_judgements 用。
  // const {
  //   fields: derivationJudgementFields,
  //   // append: appendDerivationJudgement,
  //   // remove: removeDerivationJudgement,
  // } = useFieldArray({
  //   control,
  //   name: derivationJudgementsName,
  // });

  // const defaultPsDerivationContentIndexAndNewRepresentValue = {
  //   index: -1,
  //   value: false,
  // }

  // /** 代表例チェックボックスが押下された derivation_contents の index と新しい boolean 値。 */
  // const [psDerivationContentIndexAndNewRepresentValue, setPsDerivationContentIndexAndNewRepresentValue] = useState<typeof defaultPsDerivationContentIndexAndNewRepresentValue>(defaultPsDerivationContentIndexAndNewRepresentValue);

  // useEffect(
  //   () => {
  //     if (psDerivationContentIndexAndNewRepresentValue.index >= 0) {
  //       const oldRepresentValue = getValues(`${derivationContentsName}.${psDerivationContentIndexAndNewRepresentValue.index}.represent`);

  //     }
  //   },
  //   []
  // );

  /** 追加・編集状態。 */
  const isAddingOrEditing = mode === 'Add' || mode === 'Edit';

  /** SingleSelect に渡す関数。 */
  const getValue = (valueLabelPair: string) => valueLabelPair.split(':')[0];
  /** SingleSelect に渡す関数。 */
  const getLabel = (valueLabelPair: string) => valueLabelPair.split(':')[1];

  /** Diffダイアログの表示／非表示 */
  const [isDiffDlgOpen, setIsDiffDlgOpen] = useState(false);

  /** Diffタイトル */
  const [diffTitle, setDiffTitle] = useState('');

  /** Diffダイアログの言語ID */
  const [languageId, setLanguageId] = useState(-1);

  /** 現在のPS */
  const [psValue, setPsValue] = useState<string | object | undefined>('');

  /** 一つ前のPS */
  const [psOldValue, setPsOldValue] = useState<string | object | undefined>('');

  return (
    <>
      {derivationContents &&
        (derivationContents as PsDerivationContent[]).map(
          (psDerivationContent: PsDerivationContent, derivationContentIndex: number) =>
            // derivationContentFields.map(
            //   (derivationContent: Record<'id', string>, derivationContentIndex: number) =>
            // 表示言語切替 (日本語、米語、英語) チェックボックスの状態に応じ、言語の表示 (チェック時) / 非表示 (非チェック時) を切り替える。
            displayLanguages[derivationContentIndex] && (
              <React.Fragment key={psDerivationContent.derivation_content_id}>
                {/* <React.Fragment key={derivationContent.id}> */}
                {isAddingOrEditing && (
                  <td>
                    {/* 代表例選択ラジオボタン。 */}
                    {/* React Hook Form の仕組みでは言語ごとに同じ name は設定できないので、setValue で値を設定することにする。 */}
                    <input
                      type="radio"
                      // PS ごとの言語ごとにラジオボタンの name を統一する。
                      name={`${psVersionId}-${derivationContentIndex}.represent`}
                      checked={getValues(`${derivationContentsName}.${derivationContentIndex}.represent`)}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        // 値を設定。
                        setValue(
                          `${derivationContentsName}.${derivationContentIndex}.represent`,
                          event.target.checked,
                          { shouldValidate: true, shouldDirty: true, shouldTouch: true }
                        );

                        if (event.target.checked) {
                          // 代表例が選択されたら、言語ごとに排他処理をする。
                          const derivations = getValues('derivations');

                          if (Array.isArray(derivations)) {
                            derivations.forEach((psDerivation: PsDerivation, innerDerivationIndex: number) => {
                              if (innerDerivationIndex !== psDerivationIndex) {
                                // 別の派生の場合。
                                setValue(
                                  // 同じ言語 (derivationContentIndex が同一) の別の派生。
                                  `derivations.${innerDerivationIndex}.derivation_contents.${derivationContentIndex}.represent`,
                                  // 他は false に変更。
                                  false,
                                  { shouldValidate: true, shouldDirty: true, shouldTouch: true }
                                );
                              }
                            });
                          }
                        }
                        // console.log('getValues("derivations"): ', getValues('derivations'));
                      }}
                    />
                  </td>
                )}
                <PsDerivationContentXmlCell
                  mode={mode}
                  psDerivationIndex={psDerivationIndex}
                  derivationContentIndex={derivationContentIndex}
                  psVersionId={psVersionId}
                  psDerivationContentIdDiffTypeMap={psDerivationContentIdDiffTypeMap}
                  psDerivationContentIdDiffXmlMap={psDerivationContentIdDiffXmlMap}
                  psNo={psNo}
                  psDerivationId={psDerivationId}
                  fsrId={fsrId}
                  psType={psType}
                  psLevel={psLevel}
                />
              </React.Fragment>
            )
        )}
      {
        // ルート PS と章 (L1) PS の場合は非表示。
        Number(getValues(`type`)) > 1 && <td colSpan={2} />
      }
      {
        // ルート PS と章 (L1) PS の場合は非表示。
        Number(getValues(`type`)) > 1 &&
          textConditions &&
          derivationJudgements &&
          (textConditions as PsTextCondition[]).map((psTextCondition: PsTextCondition) => {
            /** psTextCondition に対応する PsDerivationJudgement を取得。 */
            const psDerivationJudgement = (derivationJudgements as PsDerivationJudgement[]).find(
              (pDJ: PsDerivationJudgement) => pDJ.ps_text_condition_id === psTextCondition.text_condition_id
            );

            /** psDerivationJudgement の index。 */
            const psDerivationJudgementIndex = (derivationJudgements as PsDerivationJudgement[]).findIndex(
              (pDJ: PsDerivationJudgement) => pDJ.ps_text_condition_id === psTextCondition.text_condition_id
            );

            if (psDerivationJudgement) {
              const value = Number(psDerivationJudgement.value);

              const diffBackgroundColor = getDiffBackgroundColor(
                psDerivationJudgementIdDiffTypeMap,
                psDerivationJudgement.derivation_judgement_id as number
              );

              /** 背景色。 */
              const backgroundColor =
                diffBackgroundColor !== 'inherit'
                  ? diffBackgroundColor
                  : value === 1
                  ? '#ddffdd'
                  : value === 2
                  ? '#dddddd'
                  : 'inherit';

              // 削除の場合
              let newValue: string;
              let oldvalueNum: number;
              if (backgroundColor === 'OrangeRed') {
                newValue = '';
                oldvalueNum =
                  psDerivationJudgementIdDiffValueMapRef.get(Number(psDerivationJudgement.derivation_judgement_id)) ??
                  0;
              } else {
                newValue = value === 1 ? '○' : value === 2 ? '×' : '-';
                oldvalueNum =
                  psDerivationJudgementIdDiffValueMapRef.get(Number(psDerivationJudgement.derivation_judgement_id)) ??
                  0;
              }
              const oldValue = oldvalueNum === 1 ? '○' : oldvalueNum === 2 ? '×' : '-';
              return (
                <td
                  onClick={() => {
                    if (mode === 'Diff' && newValue !== oldValue) {
                      setDiffTitle('判定条件');
                      setLanguageId(-1);
                      setPsValue(newValue);
                      setPsOldValue(oldValue);
                      setIsDiffDlgOpen(true);
                    }
                  }}
                  key={psDerivationJudgement.derivation_judgement_id}
                  style={{
                    backgroundColor,
                  }}
                >
                  {isAddingOrEditing ? (
                    <SingleSelect
                      name={`${derivationJudgementsName}.${psDerivationJudgementIndex}.value` as never}
                      allowEmpty={false}
                      // 0: - (NA)
                      // 1: ○
                      // 2: ×
                      options={['0:-', '1:○', '2:×']}
                      register={register}
                      getValue={getValue}
                      getLabel={getLabel}
                      additionalClassName="tblh"
                    />
                  ) : (
                    <span
                      // 0: NA
                      // 1: ○
                      // 2: ×
                      // 「0: NA」は PS DB に合わせて「-」とする。
                      className={value === 2 ? 'batsu' : 'maru'}
                    >
                      {value === 1 ? '○' : value === 2 ? '×' : '-'}
                    </span>
                  )}
                </td>
              );
            }

            return <td key={psTextCondition.text_condition_id} />;
          })
        // &&
        // (
        //   (derivationJudgements as PsDerivationJudgement[]).map(
        //     (psDerivationJudgement: PsDerivationJudgement, psDerivationJudgementIndex: number) => {
        //       const value = Number(psDerivationJudgement.value);

        //       /** 背景色。 */
        //       let backgroundColor = (value === 1) ?
        //         '#ddffdd'
        //         :
        //         (value === 2) ?
        //           '#dddddd'
        //           :
        //           'inherit';

        //       // PS 比較画面: PS 詳細情報については、新旧 PS データで結果が異なる部分を、追加・変更された情報は黄色、削除された情報は赤色でハイライト表示する。
        //       switch (psDerivationJudgementIdDiffTypeMap.get(psDerivationJudgement.derivation_judgement_id as number)) {
        //         case 'Added':
        //         case 'Modified':
        //           backgroundColor = 'Yellow';
        //           break;

        //         case 'Deleted':
        //           backgroundColor = 'OrangeRed';
        //           break;

        //         default:
        //           break;
        //       }

        //       return (
        //         <td
        //           key={psDerivationJudgement.derivation_judgement_id}
        //           style={{
        //             backgroundColor,
        //           }}
        //         >
        //           {
        //             (isAddingOrEditing) ?
        //               (
        //                 <SingleSelect
        //                   name={`${derivationJudgementsName}.${psDerivationJudgementIndex}.value` as never}
        //                   allowEmpty={false}
        //                   // 0: - (NA)
        //                   // 1: ○
        //                   // 2: ×
        //                   options={
        //                     [
        //                       '0:-',
        //                       '1:○',
        //                       '2:×',
        //                     ]
        //                   }
        //                   register={register}
        //                   getValue={getValue}
        //                   getLabel={getLabel}
        //                   additionalClassName='tblh'
        //                 />
        //               )
        //               :
        //               (
        //                 <span
        //                   // 0: NA
        //                   // 1: ○
        //                   // 2: ×
        //                   // 「0: NA」は PS DB に合わせて「-」とする。
        //                   className={
        //                     (value === 2) ?
        //                       'batsu' : 'maru'
        //                   }
        //                 >
        //                   {
        //                     (value === 1) ?
        //                       '○'
        //                       :
        //                       (value === 2) ?
        //                         '×'
        //                         :
        //                         '-'
        //                   }
        //                 </span>
        //               )
        //           }
        //         </td>
        //       );
        //     }
        //   )
        // )
        // &&
        // (
        //   derivationJudgementFields.map(
        //     (derivationJudgement: Record<'id', string>, derivationJudgementIndex: number) => {
        //       // TODO?: getValues watch した方が早いか？
        //       const psDerivationJudgement = getValues(`${derivationJudgementsName}.${derivationJudgementIndex}`) as PsDerivationJudgement;

        //       const value = Number(psDerivationJudgement.value);

        //       /** 背景色。 */
        //       let backgroundColor = (value === 1) ?
        //         '#ddffdd'
        //         :
        //         (value === 2) ?
        //           '#dddddd'
        //           :
        //           'inherit';

        //       // PS 比較画面: PS 詳細情報については、新旧 PS データで結果が異なる部分を、追加・変更された情報は黄色、削除された情報は赤色でハイライト表示する。
        //       switch (psDerivationJudgementIdDiffTypeMap.get(psDerivationJudgement.derivation_judgement_id as number)) {
        //         case 'Added':
        //         case 'Modified':
        //           backgroundColor = 'Yellow';
        //           break;

        //         case 'Deleted':
        //           backgroundColor = 'OrangeRed';
        //           break;

        //         default:
        //           break;
        //       }

        //       return (
        //         <td
        //           key={derivationJudgement.id}
        //           style={{
        //             backgroundColor,
        //           }}
        //         >
        //           {
        //             (isAddingOrEditing) ?
        //               (
        //                 <SingleSelect
        //                   name={`${derivationJudgementsName}.${derivationJudgementIndex}.value` as never}
        //                   allowEmpty={false}
        //                   // 0: - (NA)
        //                   // 1: ○
        //                   // 2: ×
        //                   options={
        //                     [
        //                       '0:-',
        //                       '1:○',
        //                       '2:×',
        //                     ]
        //                   }
        //                   register={register}
        //                   getValue={getValue}
        //                   getLabel={getLabel}
        //                   additionalClassName='tblh'
        //                 />
        //               )
        //               :
        //               (
        //                 <span
        //                   // 0: NA
        //                   // 1: ○
        //                   // 2: ×
        //                   // 「0: NA」は PS DB に合わせて「-」とする。
        //                   className={
        //                     (value === 2) ?
        //                       'batsu' : 'maru'
        //                   }
        //                 >
        //                   {
        //                     (value === 1) ?
        //                       '○'
        //                       :
        //                       (value === 2) ?
        //                         '×'
        //                         :
        //                         '-'
        //                   }
        //                 </span>
        //               )
        //           }
        //         </td>
        //       )
        //     }
        //   )
        // )
      }
      {/* XML比較ダイアログ */}
      {isDiffDlgOpen && (
        <PsDiffViewerDialog
          isOpen={isDiffDlgOpen}
          setIsOpen={setIsDiffDlgOpen}
          titleText={diffTitle}
          langugeId={languageId}
          oldText={psOldValue}
          newText={psValue}
          oldTitle="変更前"
          newTitle="変更後"
          isXml
        />
      )}
    </>
  );
}

export default PsDerivationRow;
